

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.app', ['squid']).factory('$TransactionEligibilityModel', function ($Model, $Api) {
        return $Model.extend('TransactionEligibilityModel', {
            api: new $Api({
                uri: '/api/eligibility/transaction/:id'
            })
        });
    }).factory('$BuyerEligibilityModel', function ($Model, $Api) {
        return $Model.extend('BuyerEligibilityModel', {
            api: new $Api({
                uri: '/api/eligibility/buyer/:id'
            })
        });
    }).factory('$PXPModel', function ($Model, $Api) {
        return $Model.extend({
            api: new $Api({
                uri: '/api/pxp/:id'
            })
        });
    }).factory('$LocaleConfigModel', function ($Model, $Api) {
        return $Model.extend({
            api: new $Api({
                uri: '/api/localeConfig'
            })
        });
    }).factory('$AppDataModel', function ($Model, $Api) {
        return $Model.extend('AppDataModel', {
            api: new $Api({
                uri: '/api/app'
            }),

            isMobile: function isMobile() {
                return this.platform === 'mobile';
            }
        });
    }).factory('$MessengerIntegrationDataModel', function ($Model, $Api) {
        return $Model.extend('MessengerIntegrationDataModel', {
            api: new $Api({
                uri: '/api/messenger'
            })
        });
    }).factory('$TokenizedWalletEligibilityModel', function ($Model, $Api) {
        return $Model.extend('TokenizedWalletEligibilityModel', {
            api: new $Api({
                uri: '/api/eligibility/tokenizedWallet/:id'
            }),

            isEligible: function isEligible() {
                return this.eligible;
            }
        });
    }).factory('$TokenizedWalletPinModel', function ($Model, $Api) {
        return $Model.extend('TokenizedWalletPinModel', {
            api: new $Api({
                uri: '/api/pin/tokenizedWallet/:id'
            }),

            getPinOrigin: function getPinOrigin() {
                return this.pinOrigin;
            },
            getSuggestedPin: function getSuggestedPin() {
                return this.suggestedPin;
            },
            getSuggestedKey: function getSuggestedKey() {
                return this.suggestedKey;
            },
            getPinId: function getPinId() {
                return this.pinId;
            },
            isPinIdPresent: function isPinIdPresent() {
                return !!this.pinId;
            },
            isSetupEligible: function isSetupEligible() {
                return this.pinOrigin === 'UNSET' || this.pinOrigin === 'SYSTEM';
            }
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/app/index.js
// module id = ./components/xo-models/src/app/index.js
// module chunks = 1